module.exports = __webpack_public_path__ + "img/jcbg.0f3db01d.jpg";